import client from '../httpClient';

const sendmailBukkenTestApi = (params) => {
  return client.post('/send-mails/bukken/test', params, { isShowMessage: true });
};

export default sendmailBukkenTestApi;
